<template>
  <button
    :class="{
      [activeClass]: active,
      [lockedClass]: !unlocked,
      [unlockedClass]: unlocked && !active
    }"
    :style="{
      'transition-delay': `${active && transitioning ? transitionDuration : 0}ms`
    }"
    :disabled="!unlocked"
    role="tab"
    :id="tabId"
    :aria-controls="tabPanelId"
    :aria-label="`Step ${stepNumber} ${stepName}`"
    :aria-selected="active ? 'true' : 'false'"
    :tabindex="active ? '0' : '-1'"
    @click="goToStep(stepName)"
  >
    <slot>{{ stepNumber }}</slot>
  </button>
</template>

<script>
import {
  mapInstanceActions as mapActions, mapInstanceGetters as mapGetters, mapInstanceState as mapState
} from '@urbn/vuex-helpers';
import { SCOPED_ID_PREFIX_KEY, STORE_NAMESPACE_KEY } from './const';
import { GO_TO_STEP } from '../../store/modules/formWizard/actions';
import { ACTIVE_STEP_NAME, HIGHEST_UNLOCKED_STEP_INDEX } from '../../store/modules/formWizard/getters';
import { ACTIVE_STEP_INDEX, STEPS } from '../../store/modules/formWizard/state';

export default {
  inject: [SCOPED_ID_PREFIX_KEY, STORE_NAMESPACE_KEY],

  props: {
    activeClass: String,
    lockedClass: String,
    unlockedClass: String,

    stepName: {
      type: String,
      required: true
    },

    transitionDuration: {
      type: Number,
      default() {
        return this.$parent.transitionDuration;
      }
    }
  },

  data: () => ({
    transitioning: false
  }),

  computed: {
    ...mapGetters((vm) => vm[STORE_NAMESPACE_KEY], [
      ACTIVE_STEP_NAME,
      HIGHEST_UNLOCKED_STEP_INDEX
    ]),

    ...mapState((vm) => vm[STORE_NAMESPACE_KEY], [
      ACTIVE_STEP_INDEX,
      STEPS
    ]),

    active: (vm) => vm[ACTIVE_STEP_NAME] === vm.stepName,

    stepIndex: (vm) => vm[STEPS].findIndex((s) => s.name === vm.stepName),

    stepNumber: ({ stepIndex }) => stepIndex + 1,

    tabId() {
      return `${this[SCOPED_ID_PREFIX_KEY]}-tab-${this.stepIndex}`;
    },

    tabPanelId() {
      return `${this[SCOPED_ID_PREFIX_KEY]}-tabpanel-${this.stepIndex}`;
    },

    unlocked: (vm) => vm.stepIndex <= vm[HIGHEST_UNLOCKED_STEP_INDEX]
  },

  methods: {
    ...mapActions((vm) => vm[STORE_NAMESPACE_KEY], {
      goToStep: GO_TO_STEP
    }),
  },

  watch: {
    [ACTIVE_STEP_INDEX]() {
      clearTimeout(this.transitioningTimeoutId);

      this.transitioning = true;
      this.transitioningTimeoutId = setTimeout(() => {
        this.transitioning = false;
      }, this.transitionDuration);
    }
  }
};
</script>
